module.exports = __webpack_public_path__ + "bundles/EventSubmission/assets/images/icons/social-19944e1fb05b56f3fe57c79b5c72edb9.svg";


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/assets/images/icons/social.svg
// module id = 619
// module chunks = 0